import { render, staticRenderFns } from "./FullScreenIcon.vue?vue&type=template&id=5b3c2eb3&"
import script from "./FullScreenIcon.vue?vue&type=script&lang=js&"
export * from "./FullScreenIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports